import React from 'react';
import IrLogoRedFull from './logo/Ingersoll-Rand-logo-RGB-72-dpi.png';

// const useStyles = makeStyles({
//   svg: {
//     width: 'auto',
//     height: 30,
//   },
//   path: {
//     fill: '#7df3e1',
//   },
// });
const LogoFull = () => {
  return <img src={IrLogoRedFull} alt='Ingersoll Rand Logo'/>; 
};

export default LogoFull;
